import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { toastr } from "react-redux-toastr";
import Layout from "components/Layout";
import moment from "moment";
import {
	Dropdown,
	Button,
	ButtonGroup,
	FormControl,
	FormGroup,
} from "react-bootstrap";
import {
	FiPlus,
	FiExternalLink,
	FiMoreHorizontal,
	FiDownload,
	FiUpload,
	FiList,
	FiGrid,
} from "react-icons/fi";
import Loading from "components/Loading";
import ManagedAbsencesList from "components/Absences/ManagedAbsencesList";
import EmployeeSelectSearch from "components/EmployeeSelectSearch/EmployeeSelectSearch";
import AbsenceEditModal from "components/Absences/AbsenceEditModal";
import { showModal, hideModal, updateModalLoading } from "actions/modalActions";
import * as workflowsActions from "actions/workflowsActions";
import * as employeesActions from "actions/employeesActions";
import * as shiftsActions from "actions/shiftsActions";
import { workflowsService, appService } from "services";
import { shiftTypeQuery } from "services/shiftsService";
import { wfStatus } from "services/workflowsService";
import Modal from "components/Modal";
import "react-dates/lib/css/_datepicker.css";
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import { helpUrls } from "utils/helpUrls";
import InfiniteScroll from "react-infinite-scroll-component";

const mergeShiftsById = (...shiftLists) => {
	const shiftsById = new Map();

	shiftLists.forEach((shifts) => {
		(shifts || []).forEach((shift) => {
			if (shift?.id !== undefined && shift?.id !== null) {
				shiftsById.set(String(shift.id), shift);
			}
		});
	});

	return Array.from(shiftsById.values());
};

class AbsencesManaged extends Component {
	constructor(props) {
		super(props);
		// console.log(props);
		this.closeModal = this.closeModal.bind(this);
		this.openNewAbsenceModal = this.openNewAbsenceModal.bind(this);
		this.openEditAbsenceModal = this.openEditAbsenceModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.handleCancelRequest = this.handleCancelRequest.bind(this);
		this.handleReopenRequest = this.handleReopenRequest.bind(this);

		this.employeeSelectFetchOptions = { enabled: true };

		this.state = {
			focusedInput: null,
			employee_id: -1,
			workflow_status: "",
			shift_id: "",
			answerer_id: -1,
			isSubmit: false,
			isLoading: false,
			is_list_view: true,
			page: 0,
			page_size: 20,
			managed_absences: [],
			managed_shift_options: [],
			hasMore: true,
		};
	}

	async componentDidMount() {
		var contract_absence_shifts = true;
		contract_absence_shifts = false;
		await this.getManagedAbsences();

		await this.props.getAbsenceShifts({
			shift_type: shiftTypeQuery.absence,
			contract_only: contract_absence_shifts,
			active: null,
		});
	}

	handleChangeView = (is_list_view) => {
		this.setState({
			is_list_view,
		});
	};

	onDatesChange = (dates) => {
		var { startDate, endDate } = dates;

		if (startDate) startDate = startDate.format("YYYY-MM-DD");

		if (endDate) {
			endDate = endDate.format("YYYY-MM-DD");
		}

		this.setState(
			{
				page: 0, // reset pagination
				start_from: startDate,
				start_to: endDate,
				managed_absences: [],
				hasMore: true,
			},
			async () => {
				await this.getManagedAbsences();
			}
		);
	};

	fetchMoreData = () => {
		const { page } = this.state;
		this.setState(
			{
				page: page + 1,
			},
			() => {
				this.getManagedAbsences();
			}
		);
	};

	async getManagedAbsences() {
		this.setState({
			isLoading: this.state.page === 0, // Only show full loading on first page
		});
		const {
			start_from,
			start_to,
			employee_id,
			page,
			page_size,
			managed_absences,
			managed_shift_options,
			workflow_status,
			shift_id,
			answerer_id,
		} = this.state;

		try {
			const response = await workflowsService.getManagedAbsences({
				start_from,
				start_to,
				employee_id,
				page,
				page_size,
				workflow_status,
				shift_id,
				answerer_id,
			});

			// Handle different response structures for robustness
			let new_absences = [];
			let total_items = 0;

			if (response.data) {
				new_absences = response.data;
				if (response.pagination && response.pagination.total_items) {
					total_items = response.pagination.total_items;
				} else if (response.total) {
					// Fallback
					total_items = response.total;
				}
			} else if (Array.isArray(response)) {
				new_absences = response; // Legacy array response
			}

			let all_absences = managed_absences;
			if (page === 0) {
				all_absences = new_absences;
			} else {
				all_absences = managed_absences.concat(new_absences);
			}

			// Determine if there are more items
			let hasMore = false;
			if (new_absences.length > 0) {
				if (new_absences.length < page_size) {
					hasMore = false;
				} else if (total_items > 0) {
					hasMore = all_absences.length <= total_items;
				} else {
					// Fallback: if we got a full page, assume there might be more
					hasMore = new_absences.length === page_size;
				}
			}

			this.setState({
				managed_absences: all_absences,
				managed_shift_options: mergeShiftsById(
					managed_shift_options,
					new_absences.map((absence) => absence.shift)
				),
				isLoading: false,
				hasMore: hasMore,
			});
		} catch (error) {
			console.error("Error fetching managed absences:", error);
			this.setState({
				isLoading: false,
				hasMore: false,
			});
		}
	}

	handlePageChange = (page) => {
		this.setState({ page }, () => {
			this.getManagedAbsences();
		});
	};

	handleEmployeeFilterChange = (idOrNull) => {
		const employee_id =
			idOrNull === null || idOrNull === undefined || idOrNull === ""
				? -1
				: Number(idOrNull);
		this.setState(
			{
				employee_id,
				page: 0,
				managed_absences: [],
				hasMore: true,
			},
			async () => {
				await this.getManagedAbsences();
			}
		);
	};

	handleManagedByFilterChange = (idOrNull) => {
		const answerer_id =
			idOrNull === null || idOrNull === undefined || idOrNull === ""
				? -1
				: Number(idOrNull);
		this.applyManagedFilter({ answerer_id });
	};

	handleManagedSelectFilterChange = (event) => {
		this.applyManagedFilter({ [event.target.name]: event.target.value });
	};

	applyManagedFilter = (filter) => {
		this.setState(
			{
				...filter,
				page: 0,
				managed_absences: [],
				hasMore: true,
			},
			() => this.getManagedAbsences()
		);
	};

	closeModal() {
		this.props.hideModal();
	}

	openNewAbsenceModal() {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("absences.form.newAbsence"),
				style: { width: "430px" },
				content: <AbsenceEditModal handleClose={this.closeModal} />,
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openEditAbsenceModal(absence, disabled) {
		this.props.showModal(
			{
				open: true,
				title: disabled ? this.props.t("absences.viewAbsence") : this.props.t("absences.editAbsence"),
				style: { width: "430px" },
				content: (
					<AbsenceEditModal
						absence={absence}
						disabled={disabled}
						refreshData={() =>
							new Promise((resolve) => {
								this.setState(
									{ page: 0, managed_absences: [], hasMore: true },
									async () => {
										await this.getManagedAbsences();
										resolve();
									}
								);
							})
						}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openAlertModal(message, title) {
		this.props.showModal(
			{
				open: true,
				title: title || this.props.t("common.error"),
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	handleCancelRequest(absence) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("absences.cancelAbsence"),
				style: { width: "350px" },
				message:
					this.props.t("absences.cancelAbsenceConfirm"),
				deleteAction: () => this.confirmCancelRequest(absence),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}

	confirmCancelRequest = async (absence) => {
		absence.status = wfStatus.canceled;
		absence.shift_id = absence.shift.id;

		if (!this.state.isSubmit) {
			this.setState({ isSubmit: true });
			const response = await workflowsService.update(absence);
			this.setState({ isSubmit: false });

			// console.log(response);
			if (response.ok) {
				toastr.success(this.props.t("common.success"), this.props.t("common.changesSaved"));

				this.setState({ page: 0, managed_absences: [], hasMore: true }, () => {
					this.getManagedAbsences();
				});
				this.closeModal();
			} else {
				if (
					response.errors !== undefined &&
					Object.keys(response.errors).length > 0
				) {
					let textError = response.errors[0].description;
					this.openAlertModal(textError, this.props.t("absences.errorCancelling"));
				} else {
					this.openAlertModal(this.props.t("common.errorGeneric"), this.props.t("absences.errorCancelling"));
				}
			}
		}
	};

	// reabrir ausencia
	handleReopenRequest(absence) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("absences.reopenAbsence"),
				style: { width: "350px" },
				message: this.props.t("absences.reopenAbsenceConfirm"),
				confirmText: this.props.t("common.reopen"),
				confirmAction: () => this.confirmReopenRequest(absence),
				closeModal: this.closeModal,
			},
			"confirm"
		);
	}

	confirmReopenRequest = async (absence) => {
		absence.status = wfStatus.pending;
		absence.shift_id = absence.shift.id;
		this.openEditAbsenceModal(absence, false);

		if (!this.state.isSubmit) {
			this.setState({ isSubmit: true });
			const response = await workflowsService.update(absence);
			this.setState({ isSubmit: false });

			// console.log(response);
			if (response.ok) {
				toastr.success(this.props.t("common.success"), this.props.t("common.changesSaved"));

				this.props.getEmployeeAbsences(this.state.search_employee);
				this.openEditAbsenceModal(absence, false);
				// this.closeModal();
			} else {
				if (
					response.errors !== undefined &&
					Object.keys(response.errors).length > 0
				) {
					let textError = response.errors[0].description;
					console.log(textError);
					toastr.warning(this.props.t("absences.reopenedWithErrors"), textError);
				}
			}
		}
	};

	// exportar
	openExportAbsencesModal(token) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("absences.exportAbsences"),
				style: { width: "400px" },
				confirmText: this.props.t("common.download"),
				loadingText: this.props.t("common.downloading"),
				message:
					this.props.t("absences.exportSuccess"),
				closeModal: this.closeModal,
				confirmAction: () => {
					this.props.updateModalLoading(true);
					this.downloadExport(token, "ausencias.xlsx");
				},
			},
			"confirm"
		);
	}

	async handleExportAbsences(workflow_status) {
		const {
			start_to,
			start_from,
			employee_id,
			workflow_status: selectedStatus,
			shift_id,
			answerer_id,
		} = this.state;

		// Aprobado,Denegado (Gestionadas)  / Pendiente (Pendientes)
		const token = await workflowsService.exportWorkflows({
			workflow_status: selectedStatus || workflow_status,
			start_to,
			start_from,
			employee_id,
			shift_id,
			answerer_id,
		});

		if (token.ok) {
			this.openExportAbsencesModal(token.access_token);
		} else {
			this.openAlertModal(
				this.props.t("absences.errorExporting"),
				this.props.t("absences.errorExportingTitle")
			);
		}
	}

	async downloadExport(token, filename) {
		const response = await appService.getExported(token);
		var url = window.URL.createObjectURL(response);
		var a = document.createElement("a");
		document.body.appendChild(a);
		a.href = url;
		a.download = filename;
		a.click();

		this.props.updateModalLoading(false); // Cambiar a no cargando
		this.closeModal(); // cerrar modal de confirmación
	}

	getContent = () => {
		if (this.state.isLoading && this.state.page === 0) {
			return <Loading />;
		}

		let first_steps = "";

		if (this.state.managed_absences.length === 0 && !this.state.isLoading) {
			const step_text =
				this.props.t("absences.firstStepsAdmin");

			first_steps = (
				<div className="first-steps">
					<FiExternalLink className="icono-pasos" />
					<h3 className="title2">{this.props.t("absences.firstStepsTitle")}</h3>

					<p>
						{step_text} {this.props.t("absences.firstStepsLink")}{" "}
						<a className="alink" target="_blank" href={helpUrls.absence}>
							{helpUrls.absence}
						</a>
					</p>
				</div>
			);
		}

		const { is_list_view, managed_absences, hasMore } = this.state;

		return (
			<>
				{first_steps}
				<InfiniteScroll
					dataLength={managed_absences.length}
					next={this.fetchMoreData}
					hasMore={hasMore}
					loader={
						<div style={{ textAlign: "center", padding: "10px" }}>
							Loading...
						</div>
					}
					endMessage={
						managed_absences.length > 0 && (
							<p
								className="no-more-results"
								style={{ textAlign: "center", padding: "10px" }}
							>
								{this.props.t("absences.noMoreManaged")}
							</p>
						)
					}
				>
					<ManagedAbsencesList
						{...this.props}
						managed_absences={managed_absences}
						is_list_view={is_list_view}
						openEditAbsenceModal={this.openEditAbsenceModal}
						handleCancelRequest={this.handleCancelRequest}
						handleReopenRequest={this.handleReopenRequest}
					/>
				</InfiniteScroll>
			</>
		);
	};

	render() {
		const { is_list_view } = this.state;
		const managedStatuses = [
			wfStatus.approved,
			wfStatus.denied,
			wfStatus.canceled,
		];
		const shiftOptions = mergeShiftsById(
			this.props.shifts || [],
			this.state.managed_shift_options
		).sort((a, b) => (a.name || "").localeCompare(b.name || ""));

		return (
			<>
				<Layout className="page-absences page-absences-managed" context="absences">
					<div className="heading">
						<h1 className="title">{this.props.t("absences.managedTitle")}</h1>

						<div className="heading-filters">
								<FormGroup
									controlId="workflow_status"
									className="managed-filter-select"
								>
									<FormControl
										as="select"
										name="workflow_status"
										value={this.state.workflow_status}
										onChange={this.handleManagedSelectFilterChange}
										aria-label={this.props.t("absences.statusColumn")}
									>
										<option value="">{this.props.t("absences.allStatuses")}</option>
										{managedStatuses.map((status) => (
											<option key={status} value={status}>
												{status}
											</option>
										))}
									</FormControl>
								</FormGroup>

								<FormGroup
									controlId="shift_id"
									className="managed-filter-select"
								>
									<FormControl
										as="select"
										name="shift_id"
										value={this.state.shift_id}
										onChange={this.handleManagedSelectFilterChange}
										aria-label={this.props.t("absences.shiftColumn")}
									>
										<option value="">{this.props.t("absences.allShifts")}</option>
										{shiftOptions.map((shift) => (
											<option key={shift.id} value={shift.id}>
												{shift.name}
											</option>
										))}
									</FormControl>
								</FormGroup>

								<EmployeeSelectSearch
									className="form-select-user"
									controlId="answerer_id"
									multiple={false}
									value={
										this.state.answerer_id === -1
											? null
											: this.state.answerer_id
									}
									onChange={this.handleManagedByFilterChange}
									fetchOptions={this.employeeSelectFetchOptions}
									placeholder={this.props.t("absences.managedBy")}
									allLabel={this.props.t("absences.allManagers")}
								/>

								<EmployeeSelectSearch
									className="form-select-user mr10"
									controlId="employee_id"
									multiple={false}
									value={
										this.state.employee_id === -1
											? null
											: this.state.employee_id
									}
									onChange={this.handleEmployeeFilterChange}
									fetchOptions={this.employeeSelectFetchOptions}
									placeholder={this.props.t("common.searchEmployee")}
									allLabel={this.props.t("absences.allEmployees")}
								/>

								<DateRangePicker
									startDateId="startDateId"
									endDateId="endDateId"
									startDate={
										this.state.start_from ? moment(this.state.start_from) : null
									}
									endDate={
										this.state.start_to ? moment(this.state.start_to) : null
									}
									startDatePlaceholderText={this.props.t("common.from")}
									endDatePlaceholderText={this.props.t("common.to")}
									onDatesChange={this.onDatesChange}
									focusedInput={this.state.focusedInput}
									hideKeyboardShortcutsPanel={true}
									isOutsideRange={() => false}
									minimumNights={0}
									onFocusChange={(focusedInput) =>
										this.setState({ focusedInput })
									}
								/>

								<ButtonGroup
									className="managed-view-toggle"
									aria-label="Absences view"
								>
									<Button
										variant={`${is_list_view ? "primary" : "default"}`}
										onClick={() => this.handleChangeView(true)}
									>
										<FiList className="icon" />
									</Button>
									<Button
										variant={`${!is_list_view ? "primary" : "default"}`}
										onClick={() => this.handleChangeView(false)}
									>
										<FiGrid className="icon" />
									</Button>
								</ButtonGroup>
						</div>

						<div className="managed-primary-actions">
								<button
									type="button"
									title={this.props.t("absences.createAbsence")}
									onClick={this.openNewAbsenceModal}
									className="btn btn-new"
								>
									<FiPlus />
								</button>

								<Dropdown>
									<Dropdown.Toggle variant="action">
										<FiMoreHorizontal />
									</Dropdown.Toggle>
									<Dropdown.Menu>
										<Dropdown.Item
											as="button"
											onClick={() => this.props.history.push("/absences/import")}
										>
											<FiDownload /> {this.props.t("absences.importAbsences")}
										</Dropdown.Item>

										<Dropdown.Item
											as="button"
											onClick={() =>
												this.handleExportAbsences(`${wfStatus.approved},${wfStatus.denied}`)
											}
										>
											<FiUpload className="dropdown-icon" /> {this.props.t("absences.exportAbsences")}
										</Dropdown.Item>
									</Dropdown.Menu>
								</Dropdown>
						</div>
					</div>

					{this.getContent()}
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.shiftsReducer,
		// ...reducers.workflowsReducer, // Managed absences now local state
		...reducers.employeesReducer,
		user: reducers.authReducer.user,
		// loading: reducers.workflowsReducer.loading, // Managed locally
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	updateModalLoading: (isLoading) => dispatch(updateModalLoading(isLoading)),
	getEmployeeAbsences: (employee_id) =>
		dispatch(employeesActions.getEmployeeAbsences(employee_id)),
	getEmployeeAbsenceCalendar: (employee_id, year) =>
		dispatch(employeesActions.getEmployeeAbsenceCalendar(employee_id, year)),
	getPendingAbsences: (options) =>
		dispatch(workflowsActions.getPendingAbsences(options)),
	// getManagedAbsences: (options) => dispatch(workflowsActions.getManagedAbsences(options)), // Managed locally
	getAbsenceShifts: (options) => dispatch(shiftsActions.getAllShifts(options)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AbsencesManaged));
